import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useHelpArticlesQuery.ts
var r = (r = {}, i = {}) => t({
	queryKey: e.articles(r),
	fetchPage: (e) => n.listHelpArticles({
		...r,
		page: e
	}),
	key: "items",
	...i
});
//#endregion
export { r as useHelpArticlesQuery };
